import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { News } from '@models';

@Component({
  selector: 'prada-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent implements OnInit {
  @Input()
  news: News[];

  @Output()
  newsClick: EventEmitter<News> = new EventEmitter<News>();

  responsiveOptions;
  constructor() {
    this.responsiveOptions = [
      {
        breakpoint: '300px',
        numVisible: 3,
        numScroll: 3,
      },
    ];
  }

  ngOnInit() {}
}
